<template>
  <v-dialog v-model="isVisible" persistent fullscreen>
    <div class="fill-height" style="display: flex; flex-direction: column; background: white">
      <v-toolbar dark color="primary" style="flex: 0 1 auto">
        <v-toolbar-title v-html="title"></v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn v-if="canRestore" dark @click="onRestore">Restore</v-btn>
          <v-btn v-if="canReview" dark @click="onReview">Review</v-btn>
          <v-btn v-if="canSign" dark @click="onSign">Sign</v-btn>
          <v-btn icon dark @click="onClose"><v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <iframe ref="pdf-view" id="pdf-view" src="/assets/js/pdf/web/viewer.html?v=202308161058" class="width-full fill-height" style="overflow-y: hidden;"></iframe>
    </div>
  </v-dialog>
</template>

<script>
export default {
  props: {
    pdf: {
      type: Object|Boolean
      /* id: documentId
      *  name: name
      *  promise: data resolving
      */
    },
    title: {
      type: String,
      default: 'View PDF'
    },
    canRestore: {
      type: Boolean,
      default: false
    },
    canReview: {
      type: Boolean,
      default: false
    },
    canSign: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      visible: false,
      value: false,
      wasChanged: false,
    }
  },
  watch: {
    pdf: function(v, o) {
      this.value = v;
      this.wasChanged = false;
      if (this.value) {
        if (this.value.promise) {
          this.value.promise.then(data => this.onShow(data));
        }
      }
    }
  },
  computed: {
    isVisible: {
      get() {
        return this.visible && (typeof(this.value) === 'object');
      },
      set(value) {
        this.visible = value;
      }
    }
  },
  methods: {
    doClose() {
      window.removeEventListener('pdf.viewer:save', this.onSaveListener);
      if (!this.visible) return false;
      this.value = null;
      this.visible = false;
      return true;
    },
    onShow(data) {
      if (this.visible) return;
      this.visible = true;

      const self = this;
      this.$nextTick(() => {
        const viewer = window.document.getElementById('pdf-view');
        const onReadyListener = e => {
          window.removeEventListener('pdf.viewer:ready', onReadyListener);
          const event = new CustomEvent('pdf.viewer:set', {
            bubbles: true,
            cancelable: true,
            detail: {
              source: window,
              data,
              name: self.value.name || 'unnamed.pdf',
              id: self.value.id
            },
          });
          try {
            e.detail.source.dispatchEvent(event);
          } catch (ex) {
            console.error(`pdf.viewer:set: ${ex}`);
            (viewer.contentWindow || viewer.contentDocument.defaultView).dispatchEvent(event);
          }
        };

        window.addEventListener('pdf.viewer:ready', onReadyListener);
        window.addEventListener('pdf.viewer:save', this.onSaveListener);
        (viewer.contentWindow || viewer.contentDocument.defaultView).location.reload();
      });
    },
    onClose() {
      if (this.doClose()) this.$emit('close', this.value, this.wasChanged);
    },
    onRestore() {
      this.$emit('restore', this.value);
      this.doClose();
    },
    onReview() {
      this.$emit('review', this.value);
      this.doClose();
    },
    onSign() {
      this.$emit('sign', this.value);
      this.doClose();
    },
    onSaveListener(e) {
      this.wasChanged = true;
      if (!this.value.save || !this.visible) return;

      const self = this;
      e.detail.blob.arrayBuffer().then(data => { return this.value.save(this.value, data); })
        .then(id => {
          if (id) self.value.id = id;
        })
        .catch(self.onClose);
    }
  }
}
</script>
